import Vue from 'vue'
import batchAddGoods from './batchAddGoods'

export default {
    name: 'BatchAddGoods',
    open (options) {
        const Instance = new Vue({
            render (h) {
                return h(batchAddGoods, {
                    props: options 
                })
            }   
        })  
        const component = Instance.$mount()
        document.body.appendChild(component.$el)
        const notification = Instance.$children[0]
        return notification
    }   
}



// WEBPACK FOOTER //
// ./src/components/BatchAddGoods/index.js